/* mwf-onglets — un réglage à la fois, sur téléphone (3 octobre 2026).

   Sur l'accueil, l'aperçu arrivait après 860 px de réglages : on composait
   sans rien voir. Sur la fiche produit, il fallait le coller en haut de
   l'écran pour qu'il reste en vue. Ici les réglages se rangent sous quatre
   onglets — Couvercle, Corps, Texte, Idées — dont un seul est ouvert : l'aperçu,
   les onglets et un réglage tiennent dans un écran, sans rien coller.

   Rien n'est réécrit dans le composant. Le script pose des étiquettes
   (data-mwf-zone) sur les champs existants et ajoute trois éléments : la barre
   d'onglets, le sélecteur de format posé sur l'aperçu (accueil seulement : sur
   la fiche, le format est le produit) et le ruban d'idées. Ces ajouts ne font
   que cliquer sur les vrais boutons du composant, qui garde l'état, le prix,
   le panier et la variante.

   Sous la largeur indiquée, la barre et les champs sont rangés dans un cadre
   (.mwf-cadre), pour qu'on les lise comme un seul outil. C'est le seul
   déplacement : au-dessus de la largeur, les champs retournent dans
   .mwf-params dans leur ordre d'origine, et la version large est intacte. Le
   composant garde ses références aux éléments, pas à leur place : le
   déplacement ne change rien pour lui.

   Opt-in par l'attribut data-mwf-onglets="<largeur max en px>" sur
   <mwf-configurator> : 759 sur l'accueil (sa grille large commence à 760),
   749 sur la fiche (celle du thème à 750). Sous cette largeur, la classe
   mwf-a-onglets est posée et mwf-onglets.css fait la mise en page ; au-dessus,
   les ajouts sont masqués et la page est exactement celle d'avant. La classe
   suit une rotation de l'écran.

   Textes et idées : <script type="application/json" data-mwf-onglets>, rendu
   par snippets/mwf-onglets.liquid. Les idées sont un réglage du thème
   (Paramètres du thème › Configurateur), une ligne par combinaison. */
(function () {
  if (window.MwfOnglets) return;
  window.MwfOnglets = true;

  function textes() {
    var s = document.querySelector('script[data-mwf-onglets]');
    if (!s) return {};
    try { return JSON.parse(s.textContent); } catch (e) { return {}; }
  }
  function teinte(b) { return b ? b.style.getPropertyValue('background-color') : ''; }

  function monter(host) {
    var root = host.querySelector('.mwf');
    if (!root || !host.querySelector('[data-mwf-role="lid"]')) return false;
    if (host._mwfOnglets) return true;
    host._mwfOnglets = true;
    var txt = textes();

    // les champs du composant, reconnus par ce qu'ils contiennent
    var zones = {};
    Array.prototype.forEach.call(root.querySelectorAll('.mwf-params > .mwf-field'), function (f) {
      var role = f.getAttribute('data-mwf-role');
      var z = role === 'lid' ? 'lid' : role === 'body' ? 'body'
        : f.querySelector('.mwf-input') ? 'text'
        : f.querySelector('.mwf-pill[data-mwf-font]') ? 'font'
        : f.querySelector('.mwf-pill') ? 'format' : null;
      if (z) { f.setAttribute('data-mwf-zone', z); zones[z] = f; }
    });

    function pastille(role, nom) {
      var liste = root.querySelectorAll('[data-mwf-role="' + role + '"] .mwf-swatch');
      for (var i = 0; i < liste.length; i++) if (liste[i].getAttribute('data-mwf-color') === nom) return liste[i];
      return null;
    }

    // ── les idées : une ligne = couvercle / corps / couleur du texte ──
    var idees = (txt.idees || []).map(function (ligne) {
      var n = String(ligne).split('/').map(function (x) { return x.trim(); });
      if (n.length < 2) return null;
      var c = pastille('lid', n[0]), k = pastille('body', n[1]);
      var l = n[2] ? pastille('letter', n[2]) : null;
      return c && k ? { c: c, k: k, l: l } : null;
    }).filter(Boolean);

    // ── la barre d'onglets ──
    var barre = document.createElement('div');
    barre.className = 'mwf-onglets';
    barre.setAttribute('role', 'tablist');
    var defs = [['lid', txt.lid || 'Couvercle'], ['body', txt.body || 'Corps'], ['letter', txt.text || 'Texte']];
    if (idees.length) defs.push(['ideas', txt.ideas || 'Idées']);
    var onglets = defs.map(function (d) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'mwf-onglet';
      b.setAttribute('role', 'tab');
      b.setAttribute('data-mwf-onglet', d[0]);
      b.innerHTML = '<i aria-hidden="true"></i><span></span>';
      b.querySelector('span').textContent = d[1];
      b.addEventListener('click', function () { ouvrir(d[0]); });
      barre.appendChild(b);
      return b;
    });
    var cadre = document.createElement('div');
    cadre.className = 'mwf-cadre';
    var panneau = document.createElement('div');
    panneau.className = 'mwf-cadre__panneau';
    panneau.setAttribute('role', 'tabpanel');
    cadre.appendChild(barre);
    cadre.appendChild(panneau);
    root.appendChild(cadre);

    // ── le format, posé sur l'aperçu ──
    var format = null;
    var vue = host.querySelector('.mwf-view');
    if (zones.format && vue) {
      format = document.createElement('div');
      format.className = 'mwf-format-flottant';
      format.setAttribute('role', 'group');
      var lib = zones.format.querySelector('.mwf-label');
      if (lib) format.setAttribute('aria-label', lib.textContent);
      Array.prototype.forEach.call(zones.format.querySelectorAll('.mwf-pill'), function (vrai) {
        var b = document.createElement('button');
        b.type = 'button';
        b.textContent = vrai.textContent;
        b.addEventListener('click', function () { vrai.click(); });
        b._vrai = vrai;
        format.appendChild(b);
      });
      vue.appendChild(format);
    }

    // ── le ruban d'idées ──
    var boutonsIdees = [];
    if (idees.length) {
      var ruban = document.createElement('div');
      ruban.className = 'mwf-field mwf-idees';
      ruban.setAttribute('data-mwf-zone', 'ideas');
      ruban.setAttribute('role', 'group');
      if (txt.ideasLabel) ruban.setAttribute('aria-label', txt.ideasLabel);
      boutonsIdees = idees.map(function (x) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'mwf-idee';
        b.innerHTML = '<span class="mwf-idee__duo" aria-hidden="true"><i></i><i></i></span><span class="mwf-idee__nom"></span>';
        var duo = b.querySelectorAll('.mwf-idee__duo i');
        duo[0].style.setProperty('background-color', teinte(x.c), 'important');
        duo[1].style.setProperty('background-color', teinte(x.k), 'important');
        b.querySelector('.mwf-idee__nom').textContent = x.c.title + ' · ' + x.k.title;
        b.addEventListener('click', function () { x.c.click(); x.k.click(); if (x.l) x.l.click(); });
        b._idee = x;
        ruban.appendChild(b);
        return b;
      });
      var apres = zones.font || zones.text || zones.body;
      apres.parentNode.insertBefore(ruban, apres.nextSibling);
    }

    function ouvrir(nom) {
      host.setAttribute('data-mwf-onglet', nom);
      onglets.forEach(function (b) { b.setAttribute('aria-selected', String(b.getAttribute('data-mwf-onglet') === nom)); });
    }
    function suivre() {
      ['lid', 'body', 'letter'].forEach(function (role, i) {
        var on = root.querySelector('[data-mwf-role="' + role + '"] .mwf-swatch.is-on');
        onglets[i].querySelector('i').style.setProperty('background-color', teinte(on), 'important');
      });
      if (format) Array.prototype.forEach.call(format.children, function (b) {
        b.setAttribute('aria-pressed', String(b._vrai.classList.contains('is-on')));
      });
      var v = host.value ? host.value() : null;
      boutonsIdees.forEach(function (b) {
        var x = b._idee;
        var ok = v && v.lidKey === x.c.getAttribute('data-mwf-color') && v.bodyKey === x.k.getAttribute('data-mwf-color')
          && (!x.l || v.textColorKey === x.l.getAttribute('data-mwf-color'));
        b.setAttribute('aria-pressed', String(!!ok));
      });
    }
    ouvrir('lid');
    suivre();
    host.addEventListener('mwf:change', suivre);

    // l'ordre d'origine de la colonne de réglages, ruban d'idées compris
    var params = root.querySelector('.mwf-params');
    var ordre = Array.prototype.slice.call(params.children);
    var aRanger = ordre.filter(function (el) {
      var z = el.getAttribute('data-mwf-zone');
      return z && z !== 'format';
    });

    var mq = window.matchMedia('(max-width: ' + (parseInt(host.getAttribute('data-mwf-onglets'), 10) || 759) + 'px)');
    function appliquer() {
      if (mq.matches) {
        aRanger.forEach(function (el) { panneau.appendChild(el); });
      } else {
        ordre.forEach(function (el) { params.appendChild(el); });
      }
      host.classList.toggle('mwf-a-onglets', mq.matches);
    }
    if (mq.addEventListener) mq.addEventListener('change', appliquer); else mq.addListener(appliquer);
    appliquer();
    return true;
  }

  function amorcer() {
    Array.prototype.forEach.call(document.querySelectorAll('mwf-configurator[data-mwf-onglets]'), function (host) {
      if (monter(host)) return;
      // le composant est défini par un script defer : ses champs arrivent après nous
      var obs = new MutationObserver(function () { if (monter(host)) obs.disconnect(); });
      obs.observe(host, { childList: true, subtree: true });
      setTimeout(function () { obs.disconnect(); }, 8000);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', amorcer);
  else amorcer();
  document.addEventListener('shopify:section:load', amorcer);
})();
